"use client";

import { SYNC_WAVES } from "@stockline/web";
import { RefreshCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { BootSyncSnapshot } from "./types";

type AmbientPillProps = Readonly<{
  snapshot: BootSyncSnapshot;
}>;

export function AmbientPill({ snapshot }: AmbientPillProps) {
  const { t } = useTranslation();

  // While the warm wave is still pending, surface its progress;
  // otherwise show background-wave progress until everything lands.
  const showingWarm = snapshot.warm.state !== "completed";
  const total = showingWarm
    ? SYNC_WAVES.warm.length
    : SYNC_WAVES.background.length;
  const pendingCount = showingWarm
    ? snapshot.warmPending.length
    : snapshot.backgroundPending.length;
  const readyCount = total - pendingCount;

  return (
    <div
      data-testid="global-boot-screen-ambient"
      role="status"
      aria-live="polite"
      className="fixed right-3 top-3 z-[90] flex items-center gap-2 rounded-full border border-gray-200 bg-white/90 px-3 py-1 text-[11px] text-gray-600 shadow-sm backdrop-blur"
    >
      <RefreshCcw
        className="h-3 w-3 animate-spin text-emerald-600"
        aria-hidden
      />
      <span>
        {t("common.boot.ambient", {
          defaultValue: "Finishing background sync…",
        })}
      </span>
      <span className="tabular-nums text-gray-400">
        {readyCount} / {total}
      </span>
    </div>
  );
}
